import Http from '@/Http';
import { GET_ENTERPRISE } from '@/store/models/work/enterprises';
import { Enterprise } from '@/types/work/enterprise';
import { RootState } from '@/store';
import { MutationTree } from 'vuex';
import { PositionModel, Position } from '@/store/types/work/Positions';

export const NAMESPACE = 'work/enterprises/positions';
export const GET_POSITIONS = 'work/enterprises/positions/items';

const state: RootState = {
  status: null,
  items: [],
  item: {}
};

const getters = {
  items: (state:any):PositionModel[] => state.items,
  item: (state:any):PositionModel => state.item
};

const actions = {
  request: ({ commit, dispatch, rootGetters }:any, filter:any = {}) => {
    filter = {
      'filters[order_by]': 'title',
      ...filter
    };
    let enterprise: Enterprise = rootGetters[GET_ENTERPRISE];
    commit('request');
    (new Http()).request({ url: `enterprise/${enterprise.id}/posts`, params: filter })
      .then((resp:any) => {
        commit('success', resp.data.data);
      })
      .catch(() => {
        commit('error');
      });
  },
  storeRequest: ({ commit, rootGetters }:any, data:Position) => {
    let validData = {
      title: data.title
    };
    commit('request');
    return new Promise((resolve, reject) => {
      let enterprise: Enterprise = rootGetters[GET_ENTERPRISE];
      let url = data.id
        ? `enterprise/${enterprise.id}/positions/${data.id}`
        : `enterprise/${enterprise.id}/positions`;
      (new Http()).request({ url: url, data: validData, method: 'POST' })
        .then((resp:any) => {
          if (resp.data.data) {
            commit('successStore', { resp: data, update: !!data.id });
          }
          resolve(resp.data.data);
        })
        .catch((e:any) => {
          commit('error');
          reject(e);
        });
    });
  }
};

const mutations: MutationTree<RootState> = {
  request: (state) => {
    state.status = null;
  },
  success: (state, resp:Position[]) => {
    state.status = true;
    if (resp) {
      state.items = [];
      resp.forEach((item) => {
        state.items.push(new PositionModel(item));
      });
    }
  },
  successStore: (state, { resp, update }:any) => {
    state.status = true;
    if (update) {
      let found = false;
      for (let i = 0; i < state.items.length; i++) {
        if (state.items[i].id === resp.id) {
          state.items[i] = resp;
          found = true;
          break;
        }
      }
      if (!found) {
        state.items[state.items.length] = resp;
      }
    } else {
      state.items[state.items.length] = resp;
    }
  },
  error: (state:any) => {
    state.status = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
